import { tns } from 'tiny-slider/dist/tiny-slider'

const r18ContestCarChoice = () => {

	  if(document.querySelectorAll('.thumbnail-car__image-slider .item').length > 1) {
		  var carSelect = document.querySelector('#product');
		  let sliderOptions = {
			  container: '.thumbnail-car__image-slider',
			  items: 1,
			  startIndex: carChoices[carSelect.options[carSelect.selectedIndex].value],
			  slideBy: 'page',
			  mouseDrag: 'mouseDrag',
			  lazyload: true,
			  autoplay: false,
			  prevButton: '.thumbnail-car__image-arrow-left',
			  nextButton: '.thumbnail-car__image-arrow-right',
			  useLocalStorage: false,
		  };

		  let slider = tns(sliderOptions);

		  slider.events.on('indexChanged', function () {
			  let newValue = document.querySelectorAll('#product option')[slider.getInfo().displayIndex].value;
			  carSelect.value = newValue;
			  document.querySelector('main').setAttribute('data-id', carSelect.options[carSelect.selectedIndex].getAttribute('data-id'));
		  });
		  carSelect.addEventListener('change', e => {
			  slider.goTo(carSelect.selectedIndex - 1)
		  })

	  }

};
export default r18ContestCarChoice
